export default "/_next/static/images/apple-touch-icon-ipad-2af8558440c809f576f06a6730f8c571.png";